import {
	tea,
	coffee,
	frappe,
	shakes,
	mocktails,
	dessert,
	hotChocolate,
	lemonade,
	icedTea,
} from '../images/categoryIcons/index'

export const menu = [
	{
		name: 'Tea',
		img: tea,
		items: [
			{ Tea: 69 },
			{ 'Black Tea': 49 },
			{ 'Lemon Tea': 69 },
			{ 'Lemon Ginger Tea': 69 },
			{ 'Lemon Honey Tea': 79 },
			{ 'Lemon Honey Ginger Tea': 89 },
			{ 'Green Tea': 69 },
			{ 'Green Tea Mint': 69 },
			{ 'Green Tea Jasmine': 69 },
			{ 'Green Tea Lemon': 79 },
			{ 'Green Tea Honey': 89 },
		],
	},
	{
		name: 'Coffee',
		img: coffee,
		items: [
			{ 'Regular Coffee': 99 },
			{ 'Black Coffee': 69 },
			{ Espresso: 89 },
			{ 'Hot Americano': 119 },
			{ 'Caffe Macchiato': 119 },
			{ Cappuccino: 159 },
			{ 'Caffe Latte': 159 },
			{ 'Caffe Mocha': 179 },
			{ 'Caremal Cappuccino': 189 },
			{ 'Hazelnut Cappuccino': 209 },
			{ 'Iced Americano': 119 },
			{ 'Espresso Tonic': 119 },
			{ 'Iced Cappuccino': 169 },
			{ 'Iced Caffe Latte': 169 },
			{ 'Iced Caffe Mocha': 189 },
			{ 'Frosty Cinnamon Mocha': 209 },
		],
	},
	{
		name: 'Frappe',
		img: frappe,
		items: [
			{ 'Caffe Frappe': 139 },
			{ 'Choco Frappe': 169 },
			{ 'Choco Chill': 169 },
			{ 'Hazelnut Frappe': 179 },
			{ 'Brownie Frappe': 219 },
			{ 'Oreo Frappe': 189 },
			{ 'Oreo Hazelnut Frappe': 209 },
			{ 'Brownie Hazelnut Frappe': 249 },
		],
	},
	{
		name: 'Shakes',
		img: shakes,
		items: [
			{ 'Chocolate Shake': 159 },
			{ 'Strawberry Smoothie': 159 },
			{ 'Mango Smoothie': 159 },
			{ 'Kitkat Shake ': 169 },
			{ 'Oreo Shake': 169 },
			{ 'Brownie Shake': 199 },
			{ 'Ferrero Rocher Shake': 219 },
			{ 'Oreo Nutella Shake': 199 },
			{ 'Brownie Nutella Shake': 239 },
		],
	},
	{
		name: 'Lemonade',
		img: lemonade,
		items: [
			{ 'Fresh Lime Water': 69 },
			{ 'Fresh Lime Soda': 79 },
			{ 'Mint Lemonade (Water Based)': 89 },
			{ 'Masala Lemonade': 99 },
		],
	},
	{
		name: 'Iced Tea',
		img: icedTea,
		items: [
			{ 'Lemon Iced Tea': 129 },
			{ 'Peach Iced Tea': 129 },
			{ 'Green Apple Iced Tea': 129 },
			{ 'Strawberry Iced Tea': 129 },
			{ 'Watermelon Iced Tea': 129 },
			{ 'Red Bull Iced Tea': 189 },
			{ 'Blueberry Iced Tea': 129 },
			{ 'Guava Iced Tea': 129 },
			{ 'Passion Fruit Iced Tea': 139 },
		],
	},
	{
		name: 'Mocktails',
		img: mocktails,
		items: [
			{ 'Virgin Mojito': 119 },
			{ 'Fresh Mint Mojito': 129 },
			{ 'Strawberry Mint Mojito': 129 },
			{ 'Watermelon Mojito': 129 },
			{ 'Green Apple Mojito': 129 },
			{ 'Blue Lagoon': 129 },
			{ 'Deep Blue Sea Mojito': 129 },
			{ 'Sunrise Mocktail': 159 },
			{ 'Citrus Sunshine': 159 },
			{ 'Spicy Guava': 149 },
			{ 'Peach Punch': 149 },
			{ 'Blueberry Mojito': 129 },
			{ 'Mango Mojito': 129 },
			{ 'Guava Pinch': 139 },
			{ 'Blue Blossom': 149 },
			{ 'Pina Colada': 169 },
		],
	},
	{
		name: 'Dessert',
		img: dessert,
		items: [
			{ Affogato: 159 },
			{ 'Brownie Sunday': 149 },
			{ 'Sizzling Brownie': 189 },
			{ 'Brownie Overload': 249 },
			{ 'Oreo Choco Blast': 249 },
		],
	},
	{
		name: 'Hot Chocolate',
		img: hotChocolate,
		items: [
			{ 'Hot Chocolate': 159 },
			{ 'Kit Kat Hot Chocolate': 179 },
			{ 'Hazelnut Hot Chocolate': 179 },
			{ 'Oreo Hot Chocolate': 189 },
			{ 'Caramel Hot Chocolate': 179 },
		],
	},
]
